import { NotFoundError } from "../components";

const NotFoundPage = () => {
  return <NotFoundError />;
};

export { NotFoundPage };
